<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DUServiceModal from "@/components/modals/du-service.vue";
import TemplateModal from "@/components/modals/du-service-template.vue";
import SubscriberModal from "@/components/modals/subscriber.vue";
import FeeModal from "@/components/modals/fee-template-modal.vue";
import MapModal from '@/components/modals/map-modal.vue'
import {cloneDeep, groupBy} from "lodash";
import Swal from "sweetalert2";
import ServiceList from "@/components/widgets/service-list.vue";
import PrintOptions from "@/components/modals/print-options.vue";

export default {
    page: {
        title: "Delivery Unit Service",
    },
    components: {
        Layout,
        PageHeader,
        DUServiceModal,
        TemplateModal,
        FeeModal,
        SubscriberModal,
        MapModal,
        ServiceList,
        PrintOptions
    },
    data() {
        return {
            title: "Delivery Unit Services",
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Delivery Unit Services",
                    active: true,
                },
            ],
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            currentPage: 1,
            dus: [],
            duLoading: false,
            fundClusters: [],
            fsLoading: false,
            fundSources: [],
            services: [],
            duServices: [],
            locations: [],
            templates: [],
            modalTitle: "",
            loading: false,
            form: {
                id: 0,
                serviceName: "",
                deliveryUnitId: null,
                fundSourceId: null,
                fundClusterId: null
            },
            filter: '',
            selectedDU: null,
            selectedService: null,
            fees: [],
            filteredFees: [],
            selectedPlaceholder: null
        };
    },
    computed: {
        filteredDU(){
            let data = this.duServices;
            var total = this.currentPage * this.perPage;
            data = data.filter((item) => {
                return item.filterKey
                    .toUpperCase()
                    .includes(this.filter.toUpperCase());
            });
            data = data.slice(total - this.perPage, total);
            return data;
        },
    },
    async created(){
        this.changeCampus(this.$store.state.data.selectedCampus.id);
        this.fsLoading = true;
        await this.getFundClusters();
        this.fsLoading = false;
    },
    methods: {
        async changeCampus(id){
            this.duLoading = true;
            this.loading = true;
            await this.getServices(id);
            this.getFees(id);
            this.loading = false;
            await this.getDus(id);
            this.duLoading = false;
        },
        async getFees(id){
            await this.$store
                .dispatch("fee/getFeesByCampus", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.selected = false;
                    })
                    this.fees = res.data;
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot fetch delivery unit services.", "error");
                });
        },
        async getServices(id){
            await this.$store
                .dispatch("deliveryunitservices/getDeliveryUnitServicesByCampus", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.filterKey = `${item.deliveryUnit.name} ${item.serviceName}`;
                        item.rotateChevy = false;
                        item.templates = []
                        item.subscribers = [];
                        item.maps = [];
                        item.unpaid = [];
                        item.unpaidSummary = [];
                        item.unpaidLoading = false;
                        item.subscriberLoading = false;
                        item.mapLoading = false;
                        item.loading = false;
                        item.menuSelection = 0;
                    })
                    this.services = cloneDeep(res.data);
                    let grpData = groupBy(res.data, "deliveryUnitId");
                    let duGroup = [];
                    for (const [key, value] of Object.entries(grpData)) {
                        let filterKey = '';
                        let du = {
                            id: key,
                            name: value[0].deliveryUnit.name,
                            isOpen: true,
                            data: value,
                        };
                        value.forEach((item) => {
                            filterKey += `${item.serviceName} `;
                        });
                        duGroup.push({
                            ...du,
                            filterKey: filterKey,
                        });
                    }
                    this.duServices = duGroup;
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot fetch delivery unit services.", "error");
                });
        },
        async getFundClusters(){
            await this.$store
                .dispatch("fundcluster/GetFundCluster")
                .then((res) => {
                    if(res.data.error) return this.showToast(res.data.errorMessage, "error");
                    if(this.$store.state.decrypt.isAdmin()){
                        this.fundClusters = res.data;
                    }else{
                        const filterAccess = this.$store.state.decrypt
                        .userAccessList()
                        .filter(
                            (item) =>
                            item.Type.toLowerCase() === "finance" &&
                            item.ParentId === 118
                        );
                        let fcs = []
                        filterAccess.forEach((item) => {
                            fcs.fundClusterAccessList.push(Number(item.Access.split("-")[0]));
                        });
                        this.fundClusters = res.data.filter((item) => fcs.includes(item.id));
                    }
                })
                .catch(() => {
                this.showToast("Something went wrong! Cannot fetch fund clusters.", "error");
                });
        },
        async getDus(id){
            await this.$store
                .dispatch("deliveryunit/GetDeliveryUnitByCampus", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.dus = res.data;
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Error on fetching delivery units", "error");
                });
        },
        async getFS(id){
            this.fsLoading = true;
            await this.fetchFundSources(id);
            this.fsLoading = false;
        },
        async fetchFundSources(id){
            await this.$store
                .dispatch("fundsource/getActiveFundSource", {
                    fundClusterId: id,
                    cycle: this.$store.state.data.cycle,
                    campusId: this.$store.state.data.selectedCampus.id,
                })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.fundSources = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong! Cannot fetch fund sources.", "error");
                });
        },
        createNew(){
            this.modalTitle = "Add New Delivery Unit Service";
            this.$refs.duServiceModal.resetForm();
            this.$bvModal.show('du-service-modal');
        },
        async onSubmitDUService(modalData){
            if (modalData.id > 0) {
                this.$store
                    .dispatch("deliveryunitservices/updateDeliveryUnitService", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.selectedDU.data.findIndex((x) => x.id == modalData.id);
                        this.selectedDU.data.splice(index, 1, modalData);
                        let ind = this.services.findIndex((x) => x.id == modalData.id);
                        this.services.splice(ind, 1, modalData);
                        this.$bvModal.hide('du-service-modal');
                        this.showToast("Delivery unit service updated successfully.", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong! Cannot update delivery unit service.", "error");
                    });
            }else{
                this.$store
                    .dispatch("deliveryunitservices/createDeliveryUnitService", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.duServices.findIndex((x) => x.id == modalData.deliveryUnitId);
                        if(index > -1){
                            res.data.filterKey = `${res.data.deliveryUnit.name} ${res.data.serviceName}`;
                            res.data.rotateChevy = false;
                            this.duServices[index].data.push(res.data);
                        }else{
                            let du = this.dus.find((x) => x.id == modalData.deliveryUnitId);
                            res.data.filterKey = `${du.name} ${res.data.serviceName}`;
                            res.data.rotateChevy = false;
                            this.duServices.push({
                                id: du.id,
                                name: du.name,
                                isOpen: true,
                                data: [res.data],
                                filterKey: res.data.filterKey,
                            });
                        }
                        this.services.push(res.data);
                        this.$bvModal.hide('du-service-modal');
                        this.showToast("Delivery unit service created successfully.", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong! Cannot create delivery unit service.", "error");
                    });
            }
        },
        async editService(item, parent){
            this.selectedDU = parent;
            this.form = cloneDeep(item);
            this.form.fundClusterId = item.fundSource.fundClusterId;
            this.modalTitle = "Edit Delivery Unit Service";
            this.$refs.duServiceModal.updateData(this.form);
            this.$bvModal.show('du-service-modal');
            await this.getFS(item.fundSource.fundClusterId);
        },
        deleteService(item, parent){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("deliveryunitservices/deleteDeliveryUnitService", item.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = parent.data.findIndex((x) => x.id == item.id);
                            parent.data.splice(index, 1);
                            if(parent.data.length == 0){
                                let index = this.duServices.findIndex((x) => x.id == parent.id);
                                this.duServices.splice(index, 1);
                            }
                            let ind = this.services.findIndex((x) => x.id == item.id);
                            this.services.splice(ind, 1);
                            this.showToast("Delivery unit service deleted successfully.", "success");
                        })
                        .catch((error) => {
                            this.showToast("Something went wrong! Cannot delete delivery unit service.", "error");
                        });
                }
            });
        },
        async showTemplates(item){
            item.rotateChevy = !item.rotateChevy;
            if(item.rotateChevy && !item.templates.length){
                item.loading = true;
                await this.getDUTemplates(item)
                item.loading = false;
            }
        },
        async getDUTemplates(item){
            await this.$store
                .dispatch("duservicefeetemplate/getDUServiceFeeTemplatesByService", item.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.minimumAmount = item.minimumAmount ? item.minimumAmount.toString() : '';
                        item.minimumUnit = item.minimumUnit ? item.minimumUnit.toString() : '';
                        item.deliveryUnitServiceFees.map(x => {
                            x.editMode = false;
                            x.selected = false;
                            x.amount = x.amount ? x.amount.toString() : '';
                            x.percentage = x.percentage ? x.percentage.toString() : '';
                        });
                    })
                    item.templates = res.data;
                    this.templates = res.data;
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot fetch delivery unit service templates.", "error");
                });
        },
        addTemplate(item){
            this.selectedService = item;
            this.modalTitle = "Add New Fee Template";
            this.$refs.templateModal.resetForm();
            this.$refs.templateModal.updateData({
                id: 0,
                templateName: null,
                templateDescription: null,
            });
            this.$bvModal.show('du-service-template-modal');
        },
        onSubmitTemplate(modalData){
            modalData.deliveryUnitServiceId = this.selectedService.id;
            if (modalData.id > 0) {
                this.$store
                    .dispatch("duservicefeetemplate/updateDUServiceFeeTemplate", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.selectedService.templates.findIndex((x) => x.id == modalData.id);
                        this.selectedService.templates.splice(index, 1, modalData)
                        this.$refs[`service-${this.selectedService.deliveryUnitId}`][0].targetTemplate(this.selectedService.id, modalData);
                        this.$bvModal.hide('du-service-template-modal');
                        this.showToast("Delivery unit service updated successfully.", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong! Cannot update delivery unit service.", "error");
                    });
            }else{
                this.$store
                    .dispatch("duservicefeetemplate/createDUServiceFeeTemplate", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.deliveryUnitServiceFees = [];
                        res.data.loadingTemplate =  false;
                        this.selectedService.templates.push(res.data);
                        this.$bvModal.hide('du-service-template-modal');
                        this.showToast("Delivery unit service created successfully.", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong! Cannot create delivery unit service.", "error");
                    });
            }
        },
        editTemplate({row, parent}){
            this.selectedService = parent;
            this.modalTitle = "Update Fee Template";
            let data = cloneDeep(row);
            data.minimumUnit = row.minimumUnit ? row.minimumUnit.toString() : '';
            data.minimumAmount = row.minimumAmount ? row.minimumAmount.toString() : '';
            data.dueInDays = row.dueInDays ? row.dueInDays.toString() : '';
            this.$refs.templateModal.updateData(data);
            this.$bvModal.show('du-service-template-modal');
        },
        deleteTemplate({row, parent}){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("duservicefeetemplate/removeDUServiceFeeTemplate", row.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = parent.templates.findIndex((x) => x.id == row.id);
                            parent.templates.splice(index, 1);
                            this.$refs[`service-${parent.deliveryUnitId}`][0].targetTemplate(parent.id, {id: 0});
                            this.showToast("Template deleted successfully.", "success");
                        })
                        .catch((error) => {
                            this.showToast("Something went wrong! Cannot delete template.", "error");
                        });
                }
            });
        },
        addFees({duServices, service}){
            this.filteredFees = [];
            this.filteredFees = this.fees.filter((item) => {
                return !duServices.some((template) => template.feeId == item.id);
            });
            this.selectedService = service;
            this.modalTitle = 'Add Fees';
            this.$bvModal.show('fee-template-modal');
        },
        async addSubscriber(service, data){
            this.selectedService = service;
            this.$refs.subscriberModal.resetForm();
            this.$refs.subscriberModal.getAccNo();
            if(data){
                this.$refs.subscriberModal.addFromMap(data);
            }
            this.modalTitle = 'Add Subscriber';
            this.$bvModal.show('subscriber-modal');
            if(!service.maps.length){
                await this.getMaps(service);
            }
            if(!service.templates.length){
                await this.getDUTemplates(service);
            }
        },
        async updateSubscriber({service, data}){
            this.selectedService = service;
            this.modalTitle = 'Edit Subscriber';
            this.$refs.subscriberModal.updateData(data);
            this.$bvModal.show('subscriber-modal');
            if(!service.maps.length){
                await this.getMaps(service);
            }
        },
        removeSubscriber({service, data}){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("subscriber/RemoveSubscriber", data.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = service.subscribers.findIndex((x) => x.id == data.id);
                            service.subscribers.splice(index, 1);
                            this.showToast("Subscriber deleted successfully.", "success");
                        })
                        .catch((error) => {
                            this.showToast("Something went wrong! Cannot delete subscriber.", "error");
                        });
                }
            });
        },
        subscriberReading(service, data){
            this.selectedService = service;
            this.$refs.subscriberReadingModal.getData(data);
            this.$bvModal.show('subscriber-reading-modal');
        },
        addSelectedFees(selFees){
            this.$bvModal.hide('fee-template-modal');
            let data = []
            this.fees.map(item => item.selected = false);
            selFees.map(item => {
                data.push({
                    id: 0,
                    feeId: item.id,
                    feeName: item.name,
                    amount: item.defaultAmount.toString(),
                    percentage: '',
                    accountId: item.account.id,
                    account: item.account.accountName,
                    editMode: false,
                    selected: false,
                })
            })
            this.$refs[`service-${this.selectedService.deliveryUnitId}`][0].addFeesToTemplate(this.selectedService.id, data);
        },
        onSubmitSubscriber(modalData){
            modalData.deliveryUnitServiceId = this.selectedService.id;
            if(modalData.id > 0){
                 this.$store
                    .dispatch("subscriber/UpdateSubscriber", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.selectedService.subscribers.findIndex((x) => x.id == modalData.id);
                        this.selectedService.subscribers.splice(index, 1, modalData);
                        this.$bvModal.hide('subscriber-modal');
                        this.showToast("Subscriber updated successfully.", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong! Cannot update subscriber.", "error");
                    });
            }else{
                this.$store
                    .dispatch("subscriber/AddSubscriber", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.viewReading = false;
                        this.selectedService.subscribers.push(res.data);
                        this.$bvModal.hide('subscriber-modal');
                        this.showToast("Subscriber created successfully.", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong! Cannot update subscriber.", "error");
                    });
            }
        },
        async getSubscribers(item){
            item.subscribers = [];
            await this.$store
                .dispatch("subscriber/GetSubscriberByDUService", item.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.viewReading = false;
                        item.subscriberName = item.client.trim();
                    });
                    item.subscribers = res.data.sort((a, b) => {
                        return a.subscriberName.localeCompare(b.subscriberName);
                    });
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot fetch subscribers.", "error");
                });
        },
        async getMaps(item){
            await this.$store
                .dispatch("deliveryunitservicemap/getDeliveryUnitByService", item.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        let coordinates = JSON.parse(item.coordinates);
                        item.right = coordinates.right;
                        item.bottom = coordinates.bottom;
                        item.top = coordinates.top;
                        item.left = coordinates.left;
                    })
                    item.maps = res.data;
                    this.locations = res.data;
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot fetch maps.", "error");
                });
        },
        onSubmitMap(modalData){
            modalData.deliveryUnitServiceId = this.selectedService.id;
            if(modalData.id > 0){
                this.$store
                    .dispatch("deliveryunitservicemap/updateDeliveryUnitServiceMap", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.selectedService.maps.findIndex((x) => x.id == modalData.id);
                        this.selectedService.maps.splice(index, 1, modalData);
                        this.$bvModal.hide('map-modal');
                        this.$refs[`service-${this.selectedService.deliveryUnitId}`][0].calculateGridSize(this.selectedService.id);
                        this.showToast("Map updated successfully.", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong! Cannot update map.", "error");
                    });
            }else{
                modalData.parentDeliveryUnitServiceMapId = 0;
                let coor = {top: 0, left: 0, right: null, bottom: null}
                if(!this.selectedPlaceholder){
                    modalData.coordinates = JSON.stringify(coor);
                }else{
                    if(this.selectedPlaceholder.direction == 'right'){
                        coor = {top: this.selectedPlaceholder.sourceBox.top, left: this.selectedPlaceholder.sourceBox.id, right: null, bottom: null};
                        modalData.coordinates = JSON.stringify(coor);
                    }else if(this.selectedPlaceholder.direction == 'bottom'){
                        coor = {top: this.selectedPlaceholder.sourceBox.id, left: this.selectedPlaceholder.sourceBox.left, right: null, bottom: null};
                        modalData.coordinates = JSON.stringify(coor);
                    }else{
                        modalData.coordinates = JSON.stringify(coor)
                    }
                }
                this.$store
                    .dispatch("deliveryunitservicemap/createDeliveryUnitServiceMap", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        modalData.id = res.data.id;
                        modalData.left = coor.left;
                        modalData.top = coor.top;
                        modalData.right = coor.right;
                        modalData.bottom = coor.bottom;
                        this.selectedService.maps.push(modalData);
                        this.$bvModal.hide('map-modal');
                        this.$refs[`service-${this.selectedService.deliveryUnitId}`][0].calculateGridSize(this.selectedService.id);
                        this.showToast("Map created successfully.", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong! Cannot add map.", "error");
                    });
            }
        },
        async fetchUnpaid(item, dates){
            item.unpaidLoading = true;
            item.unpaid = [];
            if(!dates){
                await this.getUnpaidSummary(item)
            }else{
                await this.getUnpaid(item, dates);
            }
            item.unpaidLoading = false;
        },
        async getUnpaid(item, dates){
            await this.$store
                .dispatch("subscribermeterreading/GetUnpaidSubscriberMeterReadingByDUService", {id: item.id, ...dates, removeLoading: true})
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => item.selected = false);
                    item.unpaid = res.data;
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot fetch unpaid.", "error");
                });
        },
        
        async getUnpaidSummary(item){
            await this.$store
                .dispatch("subscribermeterreading/GetUnpaidSubscriberMeterReadingSummary", item.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.viewReading = false;
                        item.id = item.subscriberId;
                    });
                    item.unpaid = res.data;
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot fetch unpaid.", "error");
                });
        },
        async selectMenu({item, index}){
            item.menuSelection = index;
            if(index == 1){
                item.subscriberLoading = true;
                await this.getSubscribers(item);
                item.subscriberLoading = false;
            }else if (index == 2){
                item.mapLoading = true;
                await this.getMaps(item);
                item.mapLoading = false;
            }else if (index == 3){
                if(!item.unpaidSummary.length){
                    this.fetchUnpaid(item, null);
                }
            }
        },
        addServiceMap({placeholder, parent}){
            this.selectedService = parent;
            this.selectedPlaceholder = placeholder;
            this.$refs.mapModal.resetForm();
            this.modalTitle = 'Add Service Map';
            this.$bvModal.show('map-modal');
        },
        editServiceMap({item, parent}){
            this.selectedService = parent;
            this.modalTitle = 'Edit Service Map';
            this.$refs.mapModal.updateData(item);
            this.$bvModal.show('map-modal');
        },
        deleteServiceMap({item, parent}){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("deliveryunitservicemap/deleteDeliveryUnitServiceMap", item.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = parent.maps.findIndex((x) => x.id == item.id);
                            parent.maps.splice(index, 1);
                            this.$refs[`service-${parent.deliveryUnitId}`][0].calculateGridSize(parent.id);
                            this.showToast("Map deleted successfully.", "success");
                        })
                        .catch((error) => {
                            this.showToast("Something went wrong! Cannot delete map.", "error");
                        });
                }
            });
        },
        generateReadings(selected){
            if(selected.length == 1){
                //  && selected[0].isPosted
                this.$refs.printOpt.putOptions({
                    apiUrl: 'api/Report/DeliveryUnitService/Water/Bill', 
                    routeVariables: [selected[0].id],
                })
            }else{
                let ids = selected.map(item => item.id);
                this.$refs.printOpt.putOptions({
                    apiUrl: 'api/Report/DeliveryUnitService/Multiple/Water/Bill', 
                    routeVariables: [],
                    body: ids 
                })
            }
            this.$bvModal.show('print-options-modal')
        }
    }
}
</script>
<template>
  <Layout @changeCampus="changeCampus($event.id)">
    <PageHeader :title="title" :items="items" />
    <div id="tickets-table_filter" class="dataTables_filter me-1 d-flex justify-content-between">
        <label class="d-inline-flex align-items-center mb-0 gap-1">
            <b-form-input
                autocomplete="off"
                v-model="filter"
                type="search"
                placeholder="Search service..."
                class="form-control"
                style="width: 250px;"
            ></b-form-input>
            <b-form-select
                class="form-select"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                style="width: 90px;"
            ></b-form-select>
        </label>
        <button type="button" class="btn btn-info" @click="createNew">
          <i class="bx bx-plus me-1"></i>Create New
        </button>
    </div>
    <div class="mt-3">
        <template v-if="loading">
            <template v-for="n in 3" >
                <div :key="n" class="mb-2">
                    <div class="d-flex align-items-center mb-1" >
                        <b-skeleton
                            width="10px"
                            height="10px"
                            class="me-2"
                        ></b-skeleton>
                        <b-skeleton
                            width="250px"
                            height="25px"
                        ></b-skeleton>
                    </div>
                    <div v-for="a in 3" :key="a" class="mb-1">
                        <b-skeleton
                            width="98%"
                            height="50px"
                            class="ms-5"
                        ></b-skeleton>
                    </div>
                </div>
            </template>
        </template>
        <template v-else>
            <template v-if="!services.length">
                <div class="text-center py-5 my-5">
                    No Data Found.
                </div>
            </template>
            <template v-else>
                <div class="mt-3">
                    <template v-for="w in filteredDU">
                        <div :key="w.id">
                            <a href="javascript:void(0);" class="d-flex align-items-center my-2" @click="w.isOpen = !w.isOpen">
                                <div
                                    class="ms-1 d-flex align-items-center border border-warning text-yellow w-15px me-1"
                                >
                                    <i :class="[w.isOpen ? `bx bx-minus` : `bx bx-plus`]"></i>
                                </div>
                                <h4 class="mb-0 text-white">{{w.name}}</h4>
                            </a>
                            <div class="ms-4" v-if="w.isOpen">
                                <ServiceList
                                    :ref="`service-${w.id}`"
                                    :list="w.data"
                                    :filter="filter"
                                    :loading="loading"
                                    :canEdit="true"
                                    @show-templates="showTemplates"
                                    @select-menu="selectMenu"
                                    @add-template="addTemplate"
                                    @edit-template="editTemplate"
                                    @delete-template="deleteTemplate"
                                    @add-fees="addFees"
                                    @add-subscriber="addSubscriber"
                                    @edit-service="editService($event, w)"
                                    @delete-service="deleteService($event, w)"
                                    @add-service-map="addServiceMap"
                                    @edit-service-map="editServiceMap"
                                    @delete-service-map="deleteServiceMap"
                                    @remove-subscriber="removeSubscriber"
                                    @update-subscriber="updateSubscriber"
                                    @get-unpaid="fetchUnpaid($event.data, $event.dates)"
                                    @get-unpaid-summary="fetchUnpaid($event, null)"
                                    @generate-readings="generateReadings"
                                />
                            </div>
                        </div>
                    </template>
                </div>
            </template>
        </template>
    </div>
    <DUServiceModal
      :dus="dus"
      :duLoading="duLoading"
      :fundSources="fundSources"
      :fsLoading="fsLoading"
      :modalTitle="modalTitle"
      :fundClusters="fundClusters"
      ref="duServiceModal"
      @getFS="getFS"
      @submit="onSubmitDUService"
    />
    <TemplateModal
        ref="templateModal"
        :modalTitle="modalTitle"
        @submit="onSubmitTemplate"
    />
    <FeeModal 
        ref="feeModal"
        :fees="filteredFees"
        :modalTitle="modalTitle"
        @selected-fees="addSelectedFees"
    />
    <SubscriberModal 
        ref="subscriberModal"
        :locations="locations"
        :templates="templates"
        :modalTitle="modalTitle"
        :withReading="selectedService && selectedService.useMeterReading"
        @submit="onSubmitSubscriber"
    />
    <MapModal 
        ref="mapModal"
        :modalTitle="modalTitle"
        @submit="onSubmitMap"
    />
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>